import { createContext } from 'react'

const PlayerContext = createContext(null)

export default PlayerContext;